module.exports = __webpack_public_path__ + "static/img/10.4aa9c2c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/eng/10.png
// module id = Ml1w
// module chunks = 0